export default __webpack_public_path__ + "static/media/003-ketchup.fa2f8a11.svg";